var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"binds-list-item-button",attrs:{"type":"button","disabled":_vm.disabled}},[_c('binds-list-item-content',{attrs:{"binds-disabled":_vm.isDisabled}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }